import { Section, Eyebrow, Heading, P, PullQuote } from "../Chapter";

export const Waiting = () => (
    <Section className="relative overflow-hidden">
        <span
            aria-hidden="true"
            className="pointer-events-none absolute -left-16 top-24 -z-0 select-none font-deva text-[30vw] leading-none text-ink opacity-[0.03] md:text-[20rem]"
        >
            पत्र
        </span>
        <div className="relative">
            <Eyebrow>I. Before</Eyebrow>
            <Heading>The world of waiting</Heading>

            <P>For most of human history, a message moved at the speed of a body carrying it.</P>
            <P delay={0.05}>
                In India, that body was often a runner. Dak runners carried mail on foot between
                post stages, night and day, with bells on their staffs to warn animals off the
                road. They ran to the next stage, handed the bundle over, and someone else ran. A
                letter crossed a country the way a relay baton crosses a track — through the hands
                of dozens of people who would never read it.
            </P>
            <P delay={0.05}>
                Across water it was slower. A letter from Bombay to London went by steamer and took
                the better part of a month. Before the Suez route, around the Cape, three or four.
                You wrote a question and the answer came back in a different season.
            </P>

            <PullQuote>
                Every letter was a small act of faith — that the road held, that the ship arrived,
                that the person you were writing to was still the person you remembered.
            </PullQuote>

            <P>
                Because it was slow, it was considered. People drafted. They crossed out lines and
                began again, because paper cost money and a wasted sheet meant waiting another month
                to try. Nobody wrote <em className="italic">just checking in</em>. You wrote the
                thing that mattered, because there was one chance to say it before the season turned.
            </P>
            <P delay={0.05}>
                And because it was rare, it was kept. Letters were tied with string and put in tin
                boxes. They outlasted wars, migrations, and the people who wrote them. Somewhere in
                most old families there is still a box like that, in a language the grandchildren can
                no longer read.
            </P>
        </div>
    </Section>
);
